import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Breadcrumbs } from '../../Home/Breadcrumb';
import DatosGenerales from './DatosGenerales';
import { useSolicitud } from '../../../hooks/useSolicitud';
import {
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import DocumentosAdjuntos from './DocumentosAdjuntos';
import PersonalAfectado from './PersonalAfectado';
import EquiposAndMaquinaria from './EquiposAndMaquinaria';
import Observacion from './Observacion';
import Historial from './Historial';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  INICIO_STATUS_ID,
  ANULADA_STATUS_ID,
  REVISION_STATUS_ID,
  FINALIZADA_STATUS_ID,
  PRE_APROBADA_STATUS_ID,
  APROBADA_RT_STATUS_ID,
  EN_PROCESO_STATUS_ID,
  APROBADA_STATUS_ID,
} from '../../../constants/constants';
import MyModal from '../../../components/Modal';
import CalificarComponent from '../../../components/Calificar';
import { useObservacion } from '../../../hooks/useObservacion';
import Confirm from '../../../components/Confirm';
import { useAuth } from '../../../hooks/useAuth';
import { Loading } from '../../../components/Loading';
import DeclaracionJurada from '../../../components/DeclaracionJurada';

// import { BuscarEstado } from "./Buscar"
import { useSolicitudPermissions } from '../../../hooks/useSolicitudPermissions';
import AnalisisRiesgo from './AnalisisRiesgo';
import PlanEmergencia from './PlanEmergencia';
import { logger } from '../../../utils/logger';

export const Solicitud = () => {
  const {
    buscarSolicitud,
    solicitudSelected,
    cargarCombo,
    updateSolicitud,
    sendSolicitud,
    validarCalificarSolicitud,
    handleShowMessage,
    handleAnulada,
    validarDocumentosAprobados,
    urlVolver,
    esConAnalisisRiesgo,
    aceptarDeclaracionJurada,
  } = useSolicitud();
  const { buscarObservacionByIdSolicitud, existeCalificacion } =
    useObservacion();
  const { redirect, handleRedirect } = useAuth();

  // Estado para la calificación que se determinará en useEffect
  const [existeCalificacionState, setExisteCalificacionState] =
    useState(false);

  // Estado para verificar si la empresa gestora requiere análisis de riesgo
  const [conAnalisisRiesgo, setConAnalisisRiesgo] =
    useState<boolean>(false);

  // Estado para el modal de declaración jurada
  const [showDeclaracionJurada, setShowDeclaracionJurada] =
    useState<boolean>(false);

  // Usar el hook unificado de permisos
  const {
    isFormDisabled,
    canEditSolicitud,
    actionPermissions,
    isEmpresaGestora,
    isContratista,
  } = useSolicitudPermissions({
    solicitudEstadoId: solicitudSelected.idTipoEstado,
    tipoUsuarioCreacion: solicitudSelected.tipoUsuarioCreacion,
    existeCalificacion: existeCalificacionState,
  });

  const [estados, setEstados] = useState<any>({});
  const [isEditSolicitud, setIsEditSolicitud] =
    useState<boolean>(false);
  const [isNewSolicitud, setIsNewSolicitud] =
    useState<boolean>(false);
  const [isEnviarInicioSolicitud, setEnviarInicioSolicitud] =
    useState<boolean>(false);
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const datosGeneralesRef = useRef<any>();
  const prevIdEmpresaGestoraRef = useRef<number | null>(null);
  const [
    isOpenModalCalificarDocument,
    setIsOpenModalCalificarDocument,
  ] = useState(false);
  const [todosDocsAprobados, setTodosDocsAprobados] = useState(false);
  const [showModalFinalizar, setShowModalFinalizar] =
    useState<boolean>(false);
  const [showModalAnular, setShowModalAnular] =
    useState<boolean>(false);
  const navigate = useNavigate();
  const toggle = () => setShowModalFinalizar(!showModalFinalizar);
  const toggleAnular = () => setShowModalAnular(!showModalAnular);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const TipoAction = searchParams.get('action');
    cargarCombo('tiposEstados', setEstados);

    // Usar permissions del hook para determinar si puede editar
    setIsEditSolicitud(canEditSolicitud);

    if (id) {
      buscarSolicitud(id);
      const TipoParam = searchParams.get('create');

      if (TipoParam === 'true' || TipoAction === 'edit') {
        setIsEditSolicitud(true);
      }
      if (TipoAction === 'view') {
        setIsEditSolicitud(false);
      }
      if (TipoParam === 'true') {
        setIsNewSolicitud(true);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  // Efecto separado solo para verificar análisis de riesgo cuando cambia idEmpresaGestora
  useEffect(() => {
    if (solicitudSelected && solicitudSelected.idEmpresaGestora) {
      // Solo ejecutar si idEmpresaGestora realmente cambió
      if (
        prevIdEmpresaGestoraRef.current !==
        solicitudSelected.idEmpresaGestora
      ) {
        prevIdEmpresaGestoraRef.current =
          solicitudSelected.idEmpresaGestora;

        const verificarAnalisisRiesgo = async () => {
          try {
            const conRiesgo = await esConAnalisisRiesgo(
              Number(solicitudSelected.idEmpresaGestora)
            );
            logger.log(
              '✅ [EFECTO 1] Resultado análisis de riesgo:',
              conRiesgo
            );
            setConAnalisisRiesgo(conRiesgo);
          } catch (error) {
            logger.error(
              '❌ [EFECTO 1] Error verificando análisis de riesgo:',
              logger.safeError(error)
            );
          }
        };
        verificarAnalisisRiesgo();
      } else {
        logger.log(
          '⏭️  [EFECTO 1] ID Empresa Gestora no cambió, saltando verificación'
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [solicitudSelected.idEmpresaGestora]);

  // Efecto para resetear el modal cuando cambia el ID de la solicitud
  useEffect(() => {
    // Resetear inmediatamente cuando cambia el ID y poner en estado de carga
    setShowDeclaracionJurada(false);
    setIsLoading(true);
  }, [id]);

  // Efecto para verificar declaración jurada
  useEffect(() => {
    const TipoAction = searchParams.get('action');

    // Solo evaluar si la solicitud está completamente cargada
    // Y verificar que el ID de la solicitud coincida con el ID de la URL
    if (
      solicitudSelected.id !== 0 &&
      !isLoading &&
      solicitudSelected.id.toString() === id
    ) {
      if (
        conAnalisisRiesgo &&
        isContratista &&
        TipoAction === 'edit' &&
        solicitudSelected.idTipoEstado === APROBADA_STATUS_ID &&
        (solicitudSelected.aceptacionDDJJ === false ||
          solicitudSelected.aceptacionDDJJ === null)
      ) {
        setShowDeclaracionJurada(true);
      } else {
        // Resetear el modal si las condiciones no se cumplen
        setShowDeclaracionJurada(false);
      }
    }
  }, [
    id,
    solicitudSelected.id,
    conAnalisisRiesgo,
    isContratista,
    solicitudSelected.idTipoEstado,
    solicitudSelected.aceptacionDDJJ,
    searchParams,
    isLoading,
  ]);

  // Efecto para verificar existencia de calificación
  useEffect(() => {
    const verificarCalificacion = async () => {
      if (
        solicitudSelected.id !== 0 &&
        (solicitudSelected.idTipoEstado === REVISION_STATUS_ID ||
          solicitudSelected.idTipoEstado === PRE_APROBADA_STATUS_ID ||
          solicitudSelected.idTipoEstado === APROBADA_RT_STATUS_ID)
      ) {
        try {
          const existe = await existeCalificacion(
            solicitudSelected.id
          );
          setExisteCalificacionState(existe);
        } catch (error) {
          logger.error(
            'Error al verificar la existencia de calificacion:',
            logger.safeError(error)
          );
          setExisteCalificacionState(false);
        }
      } else {
        setExisteCalificacionState(false);
      }
    };

    verificarCalificacion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [solicitudSelected.id, solicitudSelected.idTipoEstado]);

  // Efecto para actualizar estado de edición y loading
  useEffect(() => {
    const TipoAction = searchParams.get('action');

    if (solicitudSelected && solicitudSelected.idTipoEstado !== 0) {
      // Determinar si deben mostrarse los acordeones - no necesitamos estado para esto

      // Actualizar estado de edición basado en permisos
      if (solicitudSelected.idTipoEstado === ANULADA_STATUS_ID) {
        setIsEditSolicitud(false);
      } else if (TipoAction === 'edit') {
        setIsEditSolicitud(true);
      } else if (TipoAction === 'view') {
        setIsEditSolicitud(false);
      } else {
        setIsEditSolicitud(canEditSolicitud);
      }

      // Solo establecer isLoading en false la primera vez
      setIsLoading((prevLoading) => {
        if (prevLoading === true) {
          return false;
        }
        return prevLoading;
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    solicitudSelected.id,
    solicitudSelected.idTipoEstado,
    canEditSolicitud,
    searchParams,
  ]);

  const handleAnularSolicitud = () => {
    updateSolicitud({
      id: solicitudSelected.id,
      idTipoEstado: ANULADA_STATUS_ID,
    }).then((response) => {
      if (response !== undefined) {
        // toast.success("Solicitud enviada correctamente")
        handleAnulada(true);
        navigateTo();
      }
    });
    setIsEditSolicitud(false);
    toggleAnular();
  };

  const handleEnviarSolicitud = async () => {
    if (
      isEmpresaGestora &&
      solicitudSelected.idTipoEstado === INICIO_STATUS_ID
    ) {
      setEnviarInicioSolicitud(true);
      if (datosGeneralesRef.current) {
        datosGeneralesRef.current.handleSubmitAndSend(); // Reemplaza 'guardarDatos' con el nombre de tu función en DatosGenerales.tsx
      }
    } else {
      const response = await sendSolicitud(solicitudSelected.id);

      if (response) {
        handleShowMessage(true);
        navigateTo();
      }
    }
  };

  const handleFinalizarSolicitud = () => {
    updateSolicitud({
      id: solicitudSelected.id,
      idTipoEstado: FINALIZADA_STATUS_ID,
    });
    setIsEditSolicitud(false);
    toggle();
  };
  const handleCalificarSolicitud = async () => {
    let haySinRevisar: boolean = true;
    haySinRevisar = await validarCalificarSolicitud(
      solicitudSelected.id
    );

    if (haySinRevisar !== undefined && !haySinRevisar) {
      let validarAprobados: boolean = false;
      validarAprobados = await validarDocumentosAprobados(
        solicitudSelected.id
      );
      setTodosDocsAprobados(validarAprobados);
      buscarObservacionByIdSolicitud(solicitudSelected.id);
      setIsOpenModalCalificarDocument(true);
    }
  };

  const handleVolver = () => {
    // navigate('/consultaSolicitudes')
    navigateTo();
  };

  const navigateTo = () => {
    const TipoParam = searchParams.get('create');

    if (TipoParam === 'true') {
      navigate('/consultaSolicitudes');
    } else {
      if (redirect) {
        navigate(`/solicitud/${solicitudSelected.id}/datos`);
      } else {
        navigate(urlVolver);
      }

      handleRedirect(null);
    }
  };
  const handleCancelar = () => {
    navigateTo();
  };
  const setDisableEnviar = (disabled: boolean) => {
    // Esta función ya no es necesaria con el hook unificado, pero se mantiene para compatibilidad
  };

  // Determinar si se deben mostrar los acordeones adicionales
  const shouldShowAccordions = useMemo(() => {
    // Si está en estado INICIO SOLICITUD y es Empresa Gestora o Contratista, NO mostrar acordeones
    if (
      solicitudSelected.idTipoEstado === INICIO_STATUS_ID &&
      (isEmpresaGestora || isContratista)
    ) {
      return false;
    }
    return true;
  }, [
    solicitudSelected.idTipoEstado,
    isEmpresaGestora,
    isContratista,
  ]);

  const handleAceptarDeclaracionJurada = async () => {
    try {
      await aceptarDeclaracionJurada(solicitudSelected.id, true);
      setShowDeclaracionJurada(false);
      // Recargar la solicitud para actualizar el estado de aceptacionDDJJ
      if (id) {
        await buscarSolicitud(id);
      }
    } catch (error) {
      logger.error('Error al aceptar la declaración jurada:', logger.safeError(error));
    }
  };

  const handleRechazarDeclaracionJurada = async () => {
    try {
      await aceptarDeclaracionJurada(solicitudSelected.id, false);
      setShowDeclaracionJurada(false);
      navigateTo();
    } catch (error) {
      logger.error(
        'Error al rechazar la declaración jurada:',
        logger.safeError(error)
      );
      setShowDeclaracionJurada(false);
      navigateTo();
    }
  };

  return (
    <>
      <ToastContainer />
      {isLoading || solicitudSelected.id === 0 ? (
        <Loading />
      ) : (
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">
              <Breadcrumbs
                title={
                  isNewSolicitud
                    ? 'Alta de Solicitud'
                    : isEditSolicitud
                    ? 'Edición de Solicitud'
                    : 'Vista de la Solicitud'
                }
                nameFirst={'Consulta de Solicitudes'}
                urlFirst={'/consultaSolicitudes'}
              />

              {/* Modal de Declaración Jurada */}
              <DeclaracionJurada
                isOpen={showDeclaracionJurada}
                onAccept={handleAceptarDeclaracionJurada}
                onReject={handleRechazarDeclaracionJurada}
              />

              {/* Solo mostrar el contenido si no hay modal de declaración jurada */}
              {!showDeclaracionJurada && (
                <>
                  <Confirm
                    isOpen={showModalFinalizar}
                    toggle={toggle}
                    title="Confirmar"
                    yesFn={handleFinalizarSolicitud}
                  >
                    <div className="form-horizontal">
                      <div className="row">
                        {
                          <p>
                            Está seguro que desea finalizar la
                            solicitud?
                          </p>
                        }
                      </div>
                    </div>
                  </Confirm>
                  <Confirm
                    isOpen={showModalAnular}
                    toggle={toggleAnular}
                    title="Confirmar"
                    yesFn={handleAnularSolicitud}
                  >
                    <div className="form-horizontal">
                      <div className="row">
                        {
                          <p>
                            Está seguro que desea Anular la solicitud?
                          </p>
                        }
                      </div>
                    </div>
                  </Confirm>
                  <MyModal
                    isOpen={isOpenModalCalificarDocument}
                    toggle={() =>
                      setIsOpenModalCalificarDocument(false)
                    }
                    title="Calificar Solicitud"
                    cancelButton={false}
                    secondButton={false}
                  >
                    <CalificarComponent
                      setDisabledActionEnviar={setDisableEnviar}
                      todosDocsAprobados={todosDocsAprobados}
                      enviarSolicitud={handleEnviarSolicitud}
                      cancelButtonFn={() =>
                        setIsOpenModalCalificarDocument(false)
                      }
                      returnButtonFn={() =>
                        setIsOpenModalCalificarDocument(false)
                      }
                    ></CalificarComponent>
                  </MyModal>

                  {/* <DatosGenerales ref={datosGeneralesRef} isDisabled={(solicitudSelected.idTipoEstado !== INICIO_STATUS_ID && isEmpresaGestora)
              || (isContratista && ((solicitudSelected.idTipoEstado === EN_PROCESO_STATUS_ID && solicitudSelected.tipoUsuarioCreacion != 'CONTRATISTA') || (solicitudSelected.idTipoEstado !== INICIO_STATUS_ID)))} estados={estados} isEnviarInicioSolicitud={isEnviarInicioSolicitud} setDisabledActionEnviar={setDisabledActionEnviar} /> */}
                  <DatosGenerales
                    ref={datosGeneralesRef}
                    isDisabled={
                      !isEditSolicitud ||
                      (solicitudSelected.idTipoEstado !==
                        INICIO_STATUS_ID &&
                        isEmpresaGestora) ||
                      (isContratista &&
                        ((solicitudSelected.idTipoEstado ===
                          EN_PROCESO_STATUS_ID &&
                          solicitudSelected.tipoUsuarioCreacion !==
                            'CONTRATISTA') ||
                          solicitudSelected.idTipoEstado !==
                            EN_PROCESO_STATUS_ID))
                    }
                    estados={estados}
                    isEnviarInicioSolicitud={isEnviarInicioSolicitud}
                    setDisabledActionEnviar={() => {}} // No se usa más con el nuevo hook
                    handleCancelar={handleCancelar}
                  />
                  {!isLoading &&
                    solicitudSelected.id !== 0 &&
                    shouldShowAccordions && (
                      <>
                        <DocumentosAdjuntos
                          isEdit={isEditSolicitud}
                          isDisabled={isFormDisabled}
                        />

                        <PersonalAfectado
                          isEdit={isEditSolicitud}
                          isDisabled={isFormDisabled}
                        />

                        <EquiposAndMaquinaria
                          isEdit={isEditSolicitud}
                          isDisabled={isFormDisabled}
                        />

                        {conAnalisisRiesgo && (
                          <AnalisisRiesgo
                            isEdit={isEditSolicitud}
                            isDisabled={isFormDisabled}
                          />
                        )}
                        {conAnalisisRiesgo && (
                          <PlanEmergencia
                            isEdit={isEditSolicitud}
                            isDisabled={isFormDisabled}
                          />
                        )}

                        <Observacion isDisabled={isFormDisabled} />

                        {/* <Mensaje isDisabled={!isEditSolicitud || (solicitudSelected.idTipoEstado === INICIO_STATUS_ID
              && isEmpresaGestora)} /> */}

                        <Historial isDisabled={isFormDisabled} />
                      </>
                    )}
                  <br />
                  {/* Botones */}
                  {isEditSolicitud && (
                    <div className="text-center">
                      {actionPermissions.canAnulate && (
                        <button
                          className="btn btn-danger mx-2"
                          onClick={toggleAnular}
                        >
                          Anular
                        </button>
                      )}
                      {/*<button className="btn btn-success mx-2" disabled={disabledActionGuardar} onClick={handleGuardarSolicitud}>Guardar</button> */}
                      {actionPermissions.canQualify && (
                        <button
                          className="btn btn-primary mx-2"
                          onClick={handleCalificarSolicitud}
                        >
                          Calificar
                        </button>
                      )}
                      {actionPermissions.canSend && (
                        <button
                          className="btn btn-info mx-2"
                          onClick={handleEnviarSolicitud}
                        >
                          Enviar
                        </button>
                      )}
                      {actionPermissions.canFinalize && (
                        <button
                          className="btn btn-info mx-2"
                          onClick={toggle}
                        >
                          Finalizar
                        </button>
                      )}
                      {solicitudSelected.idTipoEstado ===
                        FINALIZADA_STATUS_ID && (
                        <button
                          className="btn btn-info mx-2"
                          onClick={handleVolver}
                        >
                          Volver
                        </button>
                      )}
                    </div>
                  )}
                  {!isEditSolicitud && (
                    <div className="text-center">
                      <button
                        className="btn btn-info mx-2"
                        onClick={handleVolver}
                      >
                        Volver
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
